<template>
    <f-dialog
        v-model      = "value"
        :width       = "500"
        :show-delete = "false"
        :show-header = "false"
        @cancel      = "onCancel"
        @store       = "onSave"
    >
        <template v-slot:content>
            <c-servicepartner-edit
                v-if        = "company"
                class       = "mt-2 mb-1"
                :company    = "company"
                :show-store = "false"
                ref         = "editor"
                @stored     = "onStored"
            />
        </template>
    </f-dialog>
</template>

<script>
import FDialog from "@/modules/core/components/utils/FDialog";
import CServicepartnerEdit from "@/modules/msd/company/servicepartner/components/controlls/CServicepartnerEdit";
import Company from "@/modules/msd/company/common/service/Company";

export default {
    name: "DServicePartner",

    components: {
        CServicepartnerEdit,
        FDialog
    },

    props: {
        value: {

        },

        companyName: {

        },

        companyId: {

        },

        roles: {
            required: false,
            type: Array,
            default: function () {
                return [];
            }
        }
    },

    data: () => ({
        show: false,
        company: null
    }),

    mounted() {
        this.show = this.value;
        this.init();
    },

    watch: {
        value () {
            this.show = this.value;
            this.init();
        }
    },

    methods: {
        init () {
           if (!this.show) {
               return;
           }

           if (!this.companyId) {
               this.company = {
                   id : null,
                   name : this.companyName,
                   nameAdd : null,
                   street : null,
                   zip : null,
                   city : null,
                   weburl : null,
                   comment : null,
                   clazz : "ServiceCompanyDto",
                   status : {
                       id: 1,
                       name: ""
                   },
                   country : {
                       id: 1,
                       name: ""
                   },
                   roles: this.roles
               };
           } else {
                Company.get(this.companyId).then (data => {
                    this.company = data;
                })
           }
        },

        onCancel () {
            this.$emit("input", false)
        },

        onSave () {
            this.$refs.editor.store(() => {
                this.$emit("input", false)
            }, (error) => {
                console.log(error)
            });
        },

        onStored (company) {
            this.$emit("stored", company)
        }
    }
}
</script>

<style scoped>

</style>